import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StockSearch, StockSearchFilter, StockSearchMatch } from '../stock/stock-search';
import { StockSearchService } from '../stock/stock-search.service';

import { Message, ConfirmationService, SelectItem } from 'primeng/primeng';

@Component({
  selector: 'pl-stock-search',
  templateUrl: './stock-search.component.html',
  styleUrls: ['./stock-search.component.css'],
  providers: [ConfirmationService]
})
export class StockSearchComponent implements OnInit {

  stockSearchList: StockSearch[];
  msgs: Message[];
  selectedStockSearch: StockSearch;
  selectedStockSearchFilter: StockSearchFilter;
  selectedStockSearchMatch: StockSearchMatch;

  comparators: SelectItem[];
  fieldsUser: SelectItem[];
  fieldsStocks : SelectItem[];

  constructor(private stockSearchService: StockSearchService, private router: Router,
    private confirmationService: ConfirmationService) {
    this.stockSearchList = [];
    this.msgs = [];
    this.comparators = [];
    this.fieldsUser = [];
    this.fieldsStocks = [];
    this.selectedStockSearch = this.createDefaultStockSearch();
  }

  ngOnInit() {
    this.loadComparableFields();
    this.loadComparableStockFields();
    this.loadComparators();
    this.loadStockSearchs();
  }

  private loadComparableFields() {
    this.fieldsUser = [];
    this.fieldsUser.push({ value: 'customer.customerid', label: 'Kundennr.' });
    this.fieldsUser.push({ value: 'customer.name1', label: 'Name 1' });
    this.fieldsUser.push({ value: 'customer.name2', label: 'Name 2' });
    this.fieldsUser.push({ value: 'customer.street', label: 'Straße' });
    this.fieldsUser.push({ value: 'customer.zip', label: 'PLZ' });
    this.fieldsUser.push({ value: 'customer.city', label: 'Stadt' });
    this.fieldsUser.push({ value: 'customer.state', label: 'Bundesland' });
    this.fieldsUser.push({ value: 'customer.country', label: 'Land' });
    this.fieldsUser.push({ value: 'order.order', label: 'Auftragsnr.' });
    this.fieldsUser.push({ value: 'order.hint', label: 'Hinweis' });
    this.fieldsUser.push({ value: 'order.gate', label: 'Tor' });
    this.fieldsUser.push({ value: 'order.state', label: 'Status' });
    this.fieldsUser.push({ value: 'orderpos.pos', label: 'WA-Pos.' });
    this.fieldsUser.push({ value: 'orderpos.qtyExpected', label: 'Menge Soll' });
    this.fieldsUser.push({ value: 'orderpos.qtyReceived', label: 'Menge Ist' });
    this.fieldsUser.push({ value: 'orderpos.reservationCode', label: 'Reservierungscode' });
    this.fieldsUser.push({ value: 'orderpos.state', label: 'Pos. Status' });
    this.fieldsUser.push({ value: 'article.articleNumber', label: 'Artikelnr.' });
    this.fieldsUser.push({ value: 'article.base.unit', label: 'Basiseinheit' });
    this.fieldsUser.push({ value: 'article.receipt.unit', label: 'Liefereinheit' });
    this.fieldsUser.push({ value: 'article.receipt.baseFactor', label: 'Liefereinheitfaktor.' });
    this.fieldsUser.push({ value: 'article.weight', label: 'Artikel-Gewicht' });
    this.fieldsUser.push({ value: 'article.serialNumber', label: 'Seriennr.-KNZ' });
    this.fieldsUser.push({ value: 'article.charge', label: 'Charge-KNZ' });
    this.fieldsUser.push({ value: 'article.pickable', label: 'Kommissionierbar-KNZ' });
    this.fieldsUser.push({ value: 'article.name1', label: 'Artikelbez. 1' });
    this.fieldsUser.push({ value: 'article.name2', label: 'Artikelbez. 2' });
    this.fieldsUser.push({ value: 'article.name3', label: 'Artikelbez. 3' });
    this.fieldsUser.push({ value: 'article.name4', label: 'Artikelbez. 4' });
    this.fieldsUser.push({ value: 'article.descr', label: 'Artikelbeschreibung' });
  }

  private loadComparableStockFields() {
    this.fieldsStocks = [];
    this.fieldsStocks.push({ value: 'binLocation', label: 'Artikel-Platz' });
    this.fieldsStocks.push({ value: 'quantity', label: 'Menge' });
    this.fieldsStocks.push({ value: 'quantityFree', label: 'Menge (verügbar)' });
    this.fieldsStocks.push({ value: 'reservationCode', label: 'Reservierungscode' });
    this.fieldsStocks.push({ value: 'articleBaseUnit', label: 'Artikel-Einheit' });
    //this.fieldsStocks.push({ value: 'binLocation', label: 'Artikel-Platz' });
    /*this.fieldsStocks.push({ value: 'bin.bintype.name', label: 'Beh. Typ. Name' });
    this.fieldsStocks.push({ value: 'bin.bintype.shortname', label: 'Beh.-Typ.-Kurzname' });
    this.fieldsStocks.push({ value: 'bin.bintype.height', label: 'Beh.-Typ.-Hoehe' });
    this.fieldsStocks.push({ value: 'bin.bintype.width', label: 'Beh.-Typ.-Breite' });
    this.fieldsStocks.push({ value: 'bin.bintype.length', label: 'Beh.-Typ.-Laenge' });
    this.fieldsStocks.push({ value: 'bin.bintype.weight', label: 'Beh.-Typ.-Gewicht' });
    this.fieldsStocks.push({ value: 'bin.bintype.relativeSize', label: 'Beh.-Typ. relative Groesse' });
    this.fieldsStocks.push({ value: 'bin.weight', label: 'Beh. Gewicht' });
    this.fieldsStocks.push({ value: 'bin.barcode', label: 'Beh. Barcode' });
    this.fieldsStocks.push({ value: 'bin.location.area.name', label: 'Quelle - Bereichsname' });
    this.fieldsStocks.push({ value: 'bin.location.area.shortname', label: 'Quelle - Bereichskurzname' });
    this.fieldsStocks.push({ value: 'bin.location.area.prefix', label: 'Quelle - Bereichsprefix' });
    this.fieldsStocks.push({ value: 'bin.location.locationType.name', label: 'Quelle - Platz-Typ: Name' });
    this.fieldsStocks.push({ value: 'bin.location.locationType.picking', label: 'Quelle - Platz-Typ: Kommissionierung' });
    this.fieldsStocks.push({ value: 'bin.location.locationType.transport', label: 'Quelle - Platz-Typ: Transporte' });
    this.fieldsStocks.push({ value: 'bin.location.locationType.compact', label: 'Quelle - Platz-Typ: Verdichten' });
    this.fieldsStocks.push({ value: 'bin.location.locationType.inbound', label: 'Quelle - Platz-Typ: WE-Zone' });
    this.fieldsStocks.push({ value: 'bin.location.locationType.outbound', label: 'Quelle - Platz-Typ: WA-Zone' });
    this.fieldsStocks.push({ value: 'bin.location.locationType.count', label: 'Quelle - Platz-Typ: Kapazitaet' });
    this.fieldsStocks.push({ value: 'bin.location.barcode', label: 'Quelle - Barcode' });
    this.fieldsStocks.push({ value: 'bin.location.capacityUsed', label: 'Quelle - Kapazität (belegt)' });
    this.fieldsStocks.push({ value: 'bin.location.capacityFree', label: 'Quelle - Kapazität (frei)' });
    this.fieldsStocks.push({ value: 'bin.location.capacityMax', label: 'Quelle - Kapazität (max)' });
    this.fieldsStocks.push({ value: 'bin.location.loadUsed', label: 'Quelle - Tragkraft (belegt)' });
    this.fieldsStocks.push({ value: 'bin.location.loadFree', label: 'Quelle - Tragkraft (frei)' });
    this.fieldsStocks.push({ value: 'bin.location.loadMax', label: 'Quelle - Tragkraft (max)' });*/
  }

  private loadComparators() {
    this.comparators = [];
    this.comparators.push({ value: '=', label: '=' });
    this.comparators.push({ value: '!=', label: '!=' });
    this.comparators.push({ value: '>', label: '>' });
    this.comparators.push({ value: '<', label: '<' });
    this.comparators.push({ value: '>=', label: '>=' });
    this.comparators.push({ value: '<=', label: '<=' });
    this.comparators.push({ value: 'startsWith', label: 'Beginnt mit' });
    this.comparators.push({ value: 'endsWith', label: 'Ended mit' });
    this.comparators.push({ value: 'contains', label: 'Beinhaltet' });
    this.comparators.push({ value: 'notStartsWith', label: 'Beginnt nicht mit' });
    this.comparators.push({ value: 'notEndsWith', label: 'Ended nicht mit' });
    this.comparators.push({ value: 'notContains', label: 'Beinhaltet nicht' });
  }

  private loadStockSearchs() {
    console.log("Load StockSearches...");
    this.stockSearchService.list().subscribe(
      (stockSearchArray: StockSearch[]) => {
        //console.log("Stock searches: "+JSON.stringify(stockSearchArray));
        this.stockSearchList = [];
        this.selectedStockSearch = this.createDefaultStockSearch();
        this.selectedStockSearchFilter = null;
        this.selectedStockSearchMatch = null;
        for (var stockSearch of stockSearchArray)
          this.stockSearchList = [...this.stockSearchList, stockSearch];
      },
      (err) => {
        console.log(err);
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'Error', detail: 'Could not load list of stockSearchs.' });
      }
    );
  }

  private createDefaultStockSearch(): StockSearch {
    let stockSearch = new StockSearch();
    stockSearch.id = -1;

    stockSearch.descr = "";
    stockSearch.name = "";
    stockSearch.priority = 99;
    stockSearch.task = "";

    stockSearch.filters = [];
    stockSearch.matches = [];

    stockSearch.created = new Date();
    stockSearch.updated = new Date();
    return stockSearch;
  }

  public addNew() {
    console.log('Create new StockSearch.');

    /**
     * We need to check first, if there is already a new instance
     * in list of areas.
     */
    for (var a of this.stockSearchList) {
      if (a.id < 0) {
        this.selectedStockSearch = a;
        this.msgs.push({ severity: 'info', summary: 'Erst neuen Platz speichern.' });
        return;
      }
    }

    let stockSearch = this.createDefaultStockSearch();

    this.stockSearchList = [...this.stockSearchList, stockSearch];
    this.selectedStockSearch = stockSearch;
  }

  /**
   * Navigate to details component
   */
  public editSelected() {
  }

  public deleteSelected() {
    console.log("Delete stock type triggered");
    this.msgs = [];
    if (this.selectedStockSearch == null) {
      console.log("No stock type selected -> return");
      this.msgs.push({ severity: 'info', summary: 'Keine Strategie ausgewaehlt.' });
      return;
    }
    this.confirmationService.confirm({
      message: 'Moechten Sie die Strategie wirlich loeschen?',
      accept: () => {
        this.stockSearchService.delete(this.selectedStockSearch.id).subscribe(
          (success: any) => {
            if (success != null && success.success) {
              this.msgs.push({ severity: 'info', summary: 'Strategie wurde geloescht.' });
              this.loadStockSearchs();
            } else {
              this.msgs.push({ severity: 'warn', summary: 'Strategie konnte nicht geloescht werden.' });
              console.log('Error on serverside.');
            }
          },
          (err) => {
            this.msgs.push({ severity: 'warn', summary: 'Strategie konnte nicht geloescht werden.' });
            console.log(err);
          }
        );
      }
    });

  }

  /**
   * Saves or updates edited stockSearch entity to server.
   */
  public onSave() {
    if (this.selectedStockSearch == null || this.selectedStockSearch.id == null)
      this.msgs.push({ severity: 'info', summary: 'Please add or selected an stockSearch first.' });

    if (this.selectedStockSearch.id == -1) {
      this.stockSearchService.save(this.selectedStockSearch).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Die Strategie wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadStockSearchs();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Die Strategie konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save stockSearch, error msg: ' + err);
        }
      );
    }
    else {
      this.stockSearchService.update(this.selectedStockSearch).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Die Strategie wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.loadStockSearchs();
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Die Strategie konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save stockSearch, error msg: ' + err);
        }
      );
    }
  }


  /**
   * Helper function to edit filters and matches
   */
  public addFilter() {
    console.log('Add filter triggered.');
    if (this.selectedStockSearch != null) {
      let filter: StockSearchFilter = new StockSearchFilter();
      filter.id = 0;
      filter.comparator = '=';
      filter.field = this.fieldsStocks[0].value;
      filter.expression = '';
      filter.created = new Date();

      this.selectedStockSearch.filters = [...this.selectedStockSearch.filters, filter];
    } else {
      this.msgs = [];
      this.msgs.push({ summary: 'Bitte erst eine Strategie auswählen.' });
    }
  }

  public addMatch() {
    console.log('Add match triggered.');
    if (this.selectedStockSearch != null) {
      let match: StockSearchMatch = new StockSearchMatch();
      match.id = 0;
      match.comparator = '=';
      match.field = this.fieldsUser[0].value;
      match.expression = '';
      match.created = new Date();

      this.selectedStockSearch.matches = [...this.selectedStockSearch.matches, match];
    } else {
      this.msgs = [];
      this.msgs.push({ summary: 'Bitte erst eine Strategie auswählen.' });
    }
  }

  public deleteSelectedFilter() {
    if (this.selectedStockSearchFilter != null) {
      let filters: StockSearchFilter[] = [];
      for (var filter of this.selectedStockSearch.filters) {
        if(!this.compareFilter(filter,this.selectedStockSearchFilter))
          filters.push(filter);
      }
      this.selectedStockSearch.filters = filters;
    } else {
      this.msgs = [];
      this.msgs.push({ summary: 'Bitte erst einen Filter auswählen.' });
    }
  }

  public deleteSelectedMatch() {
    if (this.selectedStockSearchMatch != null) {
      let matches: StockSearchMatch[] = [];
      for (var match of this.selectedStockSearch.matches) {
        if(!this.compareMatch(match,this.selectedStockSearchMatch))
        matches.push(match);
      }
      this.selectedStockSearch.matches = matches;
    } else {
      this.msgs = [];
      this.msgs.push({ summary: 'Bitte erst einen Filter auswählen.' });
    }
  }

  private compareFilter(o1: StockSearchFilter, o2: StockSearchFilter): boolean {
    if (o1.comparator === o2.comparator &&
      o1.expression === o2.expression &&
      o1.field === o2.field &&
      o1.id === o2.id) {
      return true;
    } else {
      return false;
    }
  }

  private compareMatch(o1: StockSearchMatch, o2: StockSearchMatch): boolean {
    if (o1.comparator === o2.comparator &&
      o1.expression === o2.expression &&
      o1.field === o2.field &&
      o1.id === o2.id) {
      return true;
    } else {
      return false;
    }
  }
}


// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/stock-search/stock-search.component.ts